const MISSING_INSTALATIONS = 'authentication.login-missing-installation';
const LOGIN_ACTIVATE_DEPRICATED = 'authentication.login-activate-description';

export class LoginFormController {
    /* @ngInject */
    constructor(loginService,
                $state,
                $translate,
                destinationOrganization,
                toastr,
                destinationInstallation,
                authenticatedUserService,
                flowService
    ) {
        this.loginService = loginService;
        this.$state = $state;
        this.$translate = $translate;
        this.destinationOrganization = destinationOrganization;
        this.destinationInstallation = destinationInstallation;
        this.flowService = flowService;
        this.isAuthenticated = false;
        this.hasInstallation = false;
        this.validatingLogin = false;
        this.credentials = {
            username: $state.params.username
        };
        this.placeholder = '';
        this.init();
        this.toastr = toastr;
        this.toastr.options = {
            "showDuration": "6000"
        };

        if (this.onExistingUsername()) {
            authenticatedUserService.getAuthenticatedUserByUsername(this.$state.params.username)
                .then(response => {
                    this.hasNoContactPoints = response.data.contactPoints.length === 0;
                });
        }
    }

    init() {
        this.loginService.isAuthenticated().then(response => {
            this.isAuthenticated = response;
        });
        this.loginService.hasInstallation().then(response => {
            this.hasInstallation = response;
        });
    }

    login() {
        this.validatingLogin = true;
        this.loginService.login(this.credentials)
            .then(() => this.flowService.nextFlow())
            .catch(response => this._handleError(response));
    }

    onExistingUsername() {
        return this.$state.params.username !== undefined;
    }

    onAccountAuthenticationRequired() {
        return this.$state.params.authenticationRequired;
    }

    showResetPasswordLink() {
        if (this.onAccountAuthenticationRequired()) {
            return false;
        }
        if (this.onExistingUsername() && this.hasNoContactPoints) {
            return false;
        }
        return true;
    }

    _handleError(response) {
        switch (response.loginStatus) {
            case 'INCORRECT_CREDENTIALS':
                this._displayMessage('warning', 'authentication.incorrect-credentials');
                break;
            case 'PASSWORD_EXPIRED':
                this.$state.go('account.changepassword', {
                    username: this.credentials.username,
                    expired: true,
                    returnTo: 'flow'
                });
                break;
            case 'MAXIMUM_LOGIN_ATTEMPTS_EXCEEDED':
                this._displayMessage('warning', 'authentication.maximum-attempts-exceeded');
                break;
            case 'INVALID_EMAIL_DOMAIN':
                this._displayMessage('warning', 'authentication.invalid-email-domain');
                break;
            case 'ORGANIZATION_CONFLICT':
                this._displayMessage('warning', 'authentication.organization-merge-conflict');
                break;
            default:
                this._displayMessage('warning', '');
        }
        this.credentials.password = null;
        this.validatingLogin = false;
    }

    _displayMessage(type, messageCode) {
        if(messageCode) {
            this._translateMessage(type, messageCode);
        }
        if(this.isAuthenticated && !this.hasInstallation) {
            this._translateMessage(type, MISSING_INSTALATIONS);
        }
        if(this.$state.includes('login.username')) {
            this._translateMessage(type, LOGIN_ACTIVATE_DEPRICATED);
        }
    }

    _translateMessage(type, messageCode) {
        this.$translate(messageCode).then(translation => {
            this.toastr.warning(translation, type);
        });
    }
}
